import { useMemo } from 'react';
import { useMyProfile } from '../api/hooks';

export type PermissionCode =
  | 'ADMIN_ASSESSMENT'
  | 'ADMIN_ATTRIBUTE'
  | 'ADMIN_ATTRIBUTE_GROUP'
  | 'ADMIN_AUDIO_AUDIT'
  | 'ADMIN_BEHAVIORAL_FACTORS'
  | 'ADMIN_CHECKLIST'
  | 'ADMIN_CONVERSATION'
  | 'ADMIN_CONVERSATION_DELETE'
  | 'ADMIN_CONVERSATION_PIPELINE'
  | 'ADMIN_EXPERT_REPORT'
  | 'ADMIN_KNOWLEDGE'
  | 'ADMIN_PREDICTIVE_MODEL'
  | 'ADMIN_ROLE'
  | 'ADMIN_RULE'
  | 'ADMIN_SAMPLE'
  | 'ADMIN_USER'
  | 'ADMIN_STOP_WORD'
  | 'ADMIN_TERM'
  | 'ADMIN_THEMES'
  | 'ADMIN_USER_GROUP'
  | 'ADMIN_SAMPLE'
  | 'ADMIN_PREDICTIVE_MODEL'
  | 'ADMIN_JOBS'
  | 'ADMIN_COACHING'
  | 'ADMIN_KM_ENTITY_TYPE'
  | 'ADMIN_BETA_FEATURE'
  | 'ADMIN_SYSTEM_PRESET'
  | 'ADMIN_DOWNLOAD_TEMPLATE'
  | 'ADMIN_DASHBOARD_CHART_QUERY'
  | 'DEVELOPMENT'
  | 'DOWNLOAD_TRANSCRIPT_ARCHIVE'
  | 'EDIT_CONVERSATION_TRANSCRIPT'
  | 'EDIT_EXPERT_REPORT_RESULT'
  | 'VIEW_ASSESSMENT'
  | 'VIEW_ATTRIBUTE'
  | 'VIEW_ATTRIBUTE_GROUP'
  | 'VIEW_BEHAVIORAL_FACTORS'
  | 'VIEW_CHECKLIST'
  | 'VIEW_CONVERSATION'
  | 'VIEW_EXPERT_REPORT'
  | 'VIEW_EXPERT_REPORT_FEEDBACK'
  | 'VIEW_KNOWLEDGE'
  | 'VIEW_PREDICTIVE_MODEL'
  | 'VIEW_SAMPLE'
  | 'VIEW_KM_ENTITY_TYPE'
  | 'VIEW_TERM'
  | 'VIEW_STOP_WORD'
  | 'VIEW_ROLE'
  | 'VIEW_RULE'
  | 'VIEW_THEMES'
  | 'VIEW_USER'
  | 'VIEW_USER_GROUP'
  | 'VIEW_SAMPLE'
  | 'VIEW_PREDICTIVE_MODEL'
  | 'VIEW_JOBS'
  | 'VIEW_KNOWLEDGE_SOURCE'
  | 'VIEW_COACHING'
  | 'USE_AI_AGENT'
  | 'VIEW_ANONYMIZE_CONFIG'
  | 'ADMIN_ANONYMIZE_CONFIG'
  | 'VIEW_EMPLOYEE'
  | 'ADMIN_EMPLOYEE'
  | 'VIEW_EMPLOYEE_GROUP'
  | 'ADMIN_EMPLOYEE_GROUP'
  | 'VIEW_INTEGRATION_INFO'
  | 'ADMIN_INTEGRATION_INFO'
  | 'VIEW_USER_LOG'
  | 'ADMIN_USER_LOG'
  | 'VIEW_BILLING'
  | 'VIEW_GENERAL_SETTINGS'
  | 'ADMIN_GENERAL_SETTINGS';

export const usePermissionsSet = () => {
  const { data } = useMyProfile();
  return useMemo(() => new Set((data?.permissions || []).map((p) => p.code)), [data?.permissions]);
};

export const useHasPermission = (codesOrCode?: PermissionCode | PermissionCode[] | null) => {
  const set = usePermissionsSet();
  if (!codesOrCode) return true;
  return Array.isArray(codesOrCode) ? codesOrCode.some((c) => c && set.has(c)) : set.has(codesOrCode);
};

export const useHasAnyPermission = (codes: (PermissionCode | PermissionCode[] | null | undefined)[]) => {
  const set = usePermissionsSet();
  if (codes.filter(Boolean).length === 0) return true;
  return codes.some((codesOrCode) =>
    Array.isArray(codesOrCode) ? codesOrCode.some((c) => set.has(c)) : codesOrCode && set.has(codesOrCode),
  );
};
